import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown, Twitter, UserCircle, Search, Upload, Palette, Cpu, CheckCircle, RefreshCw, Brain, Map, UserSquare, Phone, FolderKanban, Globe, Megaphone, UserPlus, Database, BarChart3, Mic, Star, FileText, Zap, CheckSquare, Building2, Briefcase, GitCompare, Puzzle, BookOpen, FileBarChart, Code, Info, Handshake, Users, Mail, ArrowRight } from 'lucide-react';
export function Nav() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'shadow-lg' : ''}`} data-id="element-476" data-mp="23oi393ycv23s">
      {/* Layer 1: Top Utility Bar */}
      <div className={`bg-[#332B67] text-white overflow-hidden transition-all duration-300 border-b border-[#4a3f8a]/50 shadow-[inset_0_-1px_0_rgba(255,255,255,0.08)] ${isScrolled ? 'h-0 opacity-0' : 'hidden md:block h-[28px] opacity-100'}`} data-id="element-477" data-mp="1y3lyqq9eqc9n">
        <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between text-xs font-medium" data-id="element-478" data-mp="1k7gzzpnogaea">
          <div className="flex items-center gap-6" data-id="element-479" data-mp="2ht4olodw5of9">
            <Link to="/" className="hover:text-teal transition-colors" data-id="element-480" data-mp="2cubb3vyltxf3">
              Home
            </Link>
            <Link to="/pricing" className="hover:text-teal transition-colors" data-id="element-481" data-mp="283cq4j2o8b5i">
              Pricing
            </Link>
            <Link to="/contact" className="hover:text-teal transition-colors" data-id="element-482" data-mp="2348j9z37ypic">
              Contact
            </Link>
          </div>
          <div className="flex items-center gap-6" data-id="element-483" data-mp="30m8m5ku8clf5">
            <div className="flex items-center gap-4" data-id="element-484" data-mp="2vsnu09fbilnv">
              <span className="text-white/50" data-id="element-485" data-mp="tw58egmvsncv">Login:</span>
              <a href="https://app.1dash.pro" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors" data-id="element-486" data-mp="twot253x1pul">
                1Dash
              </a>
              <a href="https://app.dartai.com" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors" data-id="element-487" data-mp="p56nf3qy713a">
                Dart AI
              </a>
              <a href="https://thinktank.mindstream.ing" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors" data-id="element-488" data-mp="f8k7mtdhb084">
                ThinkTank
              </a>
              <a href="https://members.mindstream.ing" target="_blank" rel="noopener noreferrer" className="hover:text-teal transition-colors" data-id="element-489" data-mp="1vmk4twkxwbro">
                Community
              </a>
            </div>
            <div className="w-px h-3 bg-white/20" data-id="element-490" data-mp="25q8ll55m5d0g"></div>
            <a href="#" className="flex items-center gap-1 hover:text-teal transition-colors" data-id="element-491" data-mp="25ncqrpp2b4g8">
              <Twitter size={12} data-id="element-492" data-mp="2eplwm29dy9na" /> Follow us
            </a>
          </div>
        </div>
      </div>

      {/* Layer 2: Main Navigation */}
      <div className="bg-white border-b border-gray-200 shadow-sm" data-id="element-493" data-mp="2tdgrnpav8q3j">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-[80px]" data-id="element-494" data-mp="2ogqb70v5fshl">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 md:gap-3 shrink-0" data-id="element-495" data-mp="32eeyefcovbpt">
            <img src="https://cdn.magicpatterns.com/uploads/dWXrt9xNFh6bNpGwsjysP6/ChatGPT_Image_Mar_20,_2026,_02_15_39_PM.png" alt="MINDStream.ing icon" className="h-10 w-10 md:h-12 md:w-12 rounded-lg" data-id="element-496" data-mp="2yduzp7cgw01k" />
            <span className="font-poppins text-xl md:text-2xl font-extrabold tracking-tight" data-id="element-497" data-mp="142g8sn7pzuk8">
              <span style={{
              color: '#3D32AE'
            }} data-id="element-498" data-mp="15jddagytqxuv">
                MIND
              </span>
              <span className="text-teal font-bold" data-id="element-499" data-mp="1ej09mocp5dh2">stream</span>
              <span style={{
              color: '#3D32AE'
            }} className="italic font-bold" data-id="element-500" data-mp="1jgs1xjh971ls">
                .ing
              </span>
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8" data-id="element-501" data-mp="qqa4axzatsfr">
            {/* ═══ HOW IT WORKS MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-502" data-mp="vpmr5iq66zic">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-503" data-mp="10jqvrvbyqvg9">
                How It Works <ChevronDown size={16} data-id="element-504" data-mp="81vc47d8w8dd" />
              </span>
              <div className="absolute top-full left-0 w-[520px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-505" data-mp="80aeu9zjqbbt">
                <div className="p-6 grid grid-cols-2 gap-3" data-id="element-506" data-mp="3mpakbj3buxye">
                  <Link to="/how-it-works/meet-mr" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-507" data-mp="3mnr4ftll2ox5">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-508" data-mp="3dq70ue090gjd">
                      <UserCircle size={18} className="text-purple" data-id="element-509" data-mp="38w2u9vuwaait" />
                    </div>
                    <div data-id="element-510" data-mp="33wzxszszdcmg">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-511" data-mp="2yzzp0h4qxvrn">
                        1. Meet MR
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-512" data-mp="2uxcxyifwgevi">
                        Quick intro call to get started
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/business-deep-dive" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-513" data-mp="2gamimd5cclqx">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-514" data-mp="26et972mx58dd">
                      <Search size={18} className="text-purple" data-id="element-515" data-mp="2bd4hh8xkfath" />
                    </div>
                    <div data-id="element-516" data-mp="2z2p4q40r4u8k">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-517" data-mp="2z49wjlvolz2q">
                        2. Business Deep Dive
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-518" data-mp="2pd5hkm60ae7w">
                        We learn how your business runs
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/intake-upload" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-519" data-mp="3i0rljvj5bkva">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-520" data-mp="1bbzi79zqzst3">
                      <Upload size={18} className="text-purple" data-id="element-521" data-mp="16cwje7ad2itk" />
                    </div>
                    <div data-id="element-522" data-mp="1k41dktuymiwi">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-523" data-mp="1k4b3khg08q27">
                        3. Intake & Upload
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-524" data-mp="sdeqbfq18jee">
                        Bring your tools & data together
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/brand-persona" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-525" data-mp="11ectxwwk6owg">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-526" data-mp="2ct8lgjgb0kuf">
                      <Palette size={18} className="text-purple" data-id="element-527" data-mp="27vgi8ta7lcax" />
                    </div>
                    <div data-id="element-528" data-mp="2rxbbfdebf22t">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-529" data-mp="2ry2vps2gpdds">
                        4. Brand Persona
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-530" data-mp="30xhncuud7tzv">
                        Create your unique brand voice
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/create-agents" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-531" data-mp="35q0xtixra90g">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-532" data-mp="3klgyw7wr756c">
                      <Cpu size={18} className="text-purple" data-id="element-533" data-mp="3omsfjnxngg2e" />
                    </div>
                    <div data-id="element-534" data-mp="1q7frgyn519un">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-535" data-mp="1q87mo8ctp5ke">
                        5. Create Agents
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-536" data-mp="1u9az0kvnwjgv">
                        Your AI agents go live
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/review-process" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-537" data-mp="1hx8pkh2mu0m2">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-538" data-mp="18zybknyfjxdg">
                      <CheckCircle size={18} className="text-purple" data-id="element-539" data-mp="25m9ys6jahfse" />
                    </div>
                    <div data-id="element-540" data-mp="20n6tckzed7jw">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-541" data-mp="1wnfvxyfd7t6e">
                        6. Review Process
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-542" data-mp="1rntj3q3g8ey4">
                        Make sure everything works
                      </div>
                    </div>
                  </Link>
                  <Link to="/how-it-works/revamp-repeat" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors col-span-2" data-id="element-543" data-mp="g8eq0xed278a">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-544" data-mp="1cwfl2gptr23">
                      <RefreshCw size={18} className="text-purple" data-id="element-545" data-mp="f418zmthpn3z" />
                    </div>
                    <div data-id="element-546" data-mp="aaq9k6r0c8m3">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-547" data-mp="p0xj1wz1ehan">
                        7. Revamp & Repeat
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-548" data-mp="k0rpucd4cmqg">
                        Optimize and grow continuously
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="bg-gray-50 p-3 rounded-b-xl border-t border-gray-100 text-center" data-id="element-549" data-mp="u0igu42h0jls">
                  <Link to="/how-it-works" className="text-xs font-semibold text-teal hover:text-navy-dark transition-colors inline-flex items-center gap-1" data-id="element-550" data-mp="2zth4gv3nlzzy">
                    View Full Process <ArrowRight size={12} data-id="element-551" data-mp="2pp0qy8dncuzb" />
                  </Link>
                </div>
              </div>
            </div>

            {/* ═══ FEATURES MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-552" data-mp="2bxdkjfpzq62t">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-553" data-mp="2gvosfkwq66ie">
                Features <ChevronDown size={16} data-id="element-554" data-mp="21y4ugxy8xblq" />
              </span>
              <div className="absolute top-full left-1/2 -translate-x-1/2 w-[900px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-555" data-mp="26zlr2h9p6bwi">
                <div className="p-6 grid grid-cols-4 gap-6" data-id="element-556" data-mp="3ncspp6scs490">
                  {/* Column 1: AI Brain */}
                  <div data-id="element-557" data-mp="3sblt26dxeevg">
                    <h3 className="font-poppins font-semibold text-teal mb-4 text-xs uppercase tracking-wider" data-id="element-558" data-mp="3sc5cxsn4zdc4">
                      Your AI Brain
                    </h3>
                    <div className="flex flex-col gap-1" data-id="element-559" data-mp="3lvve6t2u00ov">
                      <Link to="/think-tank" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-560" data-mp="3lubx509cplm1">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-561" data-mp="3bza6u13cadhv">
                          <Brain size={16} className="text-teal" data-id="element-562" data-mp="dhmru2qwk655" />
                        </div>
                        <div data-id="element-563" data-mp="8j36a3g80wdb">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-564" data-mp="3pgzgrwqnmpf">
                            ThinkTank
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-565" data-mp="3uw1pq9eyyqle">
                            AI-powered strategy hub
                          </div>
                        </div>
                      </Link>
                      <Link to="/live-mind-maps" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-566" data-mp="rdi6txi6kx39">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-567" data-mp="13rnj5lxgp3k7">
                          <Map size={16} className="text-teal" data-id="element-568" data-mp="1dnqmgv41v88q" />
                        </div>
                        <div data-id="element-569" data-mp="1hpvb1ffn5eoi">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-570" data-mp="1hok97l5rah01">
                            Live Mind Maps
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-571" data-mp="1mmc2aii5095t">
                            Visual business intelligence
                          </div>
                        </div>
                      </Link>
                      <Link to="/persona-builder" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-572" data-mp="21dumksi14puz">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-573" data-mp="333j44c982exu">
                          <UserSquare size={16} className="text-teal" data-id="element-574" data-mp="2y3wsu8cyf8ro" />
                        </div>
                        <div data-id="element-575" data-mp="3bvbbge2y97y7">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-576" data-mp="3bvl5ccr47z96">
                            Persona Builder
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-577" data-mp="2k4ezdfopr7bz">
                            Define your brand identity
                          </div>
                        </div>
                      </Link>
                      <Link to="/dedicated-line" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-578" data-mp="2t6xwdj5tipqb">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-579" data-mp="8ecl5m8x0nba">
                          <Phone size={16} className="text-teal" data-id="element-580" data-mp="3gb6ddiiva5m" />
                        </div>
                        <div data-id="element-581" data-mp="bwa4x9yjs0s5">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-582" data-mp="fz6s7dz18l2f">
                            Dedicated Line
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-583" data-mp="20ymagk0q9f4">
                            Your own AI phone number
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  {/* Column 2: Your Business */}
                  <div data-id="element-584" data-mp="zmmgqvwwyho0">
                    <h3 className="font-poppins font-semibold text-teal mb-4 text-xs uppercase tracking-wider" data-id="element-585" data-mp="zoyyb7yreq0j">
                      Your Business
                    </h3>
                    <div className="flex flex-col gap-1" data-id="element-586" data-mp="pvrtppbufe1i">
                      <Link to="/project-manager" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-587" data-mp="1dmfal03qle07">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-588" data-mp="1s9vy9rp9ammu">
                          <FolderKanban size={16} className="text-teal" data-id="element-589" data-mp="1nb2mq4tj55pb" />
                        </div>
                        <div data-id="element-590" data-mp="1i9vfc6vau8j6">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-591" data-mp="1idawrgcg3tnr">
                            Project Manager
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-592" data-mp="19bjpi729bers">
                            Tasks that manage themselves
                          </div>
                        </div>
                      </Link>
                      <Link to="/self-building-website" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-593" data-mp="zlhzh9qcfma8">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-594" data-mp="qmd3ob66271r">
                          <Globe size={16} className="text-teal" data-id="element-595" data-mp="2x8j5bdpcudtn" />
                        </div>
                        <div data-id="element-596" data-mp="327m1e8ncx9ph">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-597" data-mp="326uernbqmmbc">
                            Self-Building Website
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-598" data-mp="367eemynp4416">
                            Sites that build & update
                          </div>
                        </div>
                      </Link>
                      <Link to="/self-running-marketing" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-599" data-mp="2ijmqmxssm2k2">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-600" data-mp="2s9zjddarh21a">
                          <Megaphone size={16} className="text-teal" data-id="element-601" data-mp="1ut0v25zz6aqy" />
                        </div>
                        <div data-id="element-602" data-mp="1zs3osuai8ujm">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-603" data-mp="1zrbzu2bexv2b">
                            Self-Running Marketing
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-604" data-mp="o7rov8z285fh">
                            Marketing on autopilot
                          </div>
                        </div>
                      </Link>
                      <Link to="/onboarding-agents" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-605" data-mp="y44ftz38056j">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-606" data-mp="1752mkp51mqst">
                          <UserPlus size={16} className="text-teal" data-id="element-607" data-mp="1lwkwq6b81r49" />
                        </div>
                        <div data-id="element-608" data-mp="1gxi2lgws55b2">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-609" data-mp="1uuwvivm8rv7s">
                            Onboarding Agents
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-610" data-mp="1pxwpgkpe6sgo">
                            Automate client onboarding
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  {/* Column 3: Your Growth */}
                  <div data-id="element-611" data-mp="20j9wm99dy6b6">
                    <h3 className="font-poppins font-semibold text-teal mb-4 text-xs uppercase tracking-wider" data-id="element-612" data-mp="24isjhakrorgn">
                      Your Growth
                    </h3>
                    <div className="flex flex-col gap-1" data-id="element-613" data-mp="1qpawtgwsayme">
                      <Link to="/self-managing-crm" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-614" data-mp="1vj5pvaya4py5">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-615" data-mp="1lt2nik59pzn5">
                          <Database size={16} className="text-teal" data-id="element-616" data-mp="17tbcmsa1szdd" />
                        </div>
                        <div data-id="element-617" data-mp="1cqtbtqy9k086">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-618" data-mp="1aypqzcyrzqj0">
                            Self-Managing CRM
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-619" data-mp="1fzdpskt8xbns">
                            CRM that runs itself
                          </div>
                        </div>
                      </Link>
                      <Link to="/advanced-analytics" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-620" data-mp="16xe9juq22blw">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-621" data-mp="1yqenl5imr15r">
                          <BarChart3 size={16} className="text-teal" data-id="element-622" data-mp="1pw09h69u5wo8" />
                        </div>
                        <div data-id="element-623" data-mp="2dlkwc0941e2s">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-624" data-mp="2dlb74evw3ay5">
                            Advanced Analytics
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-625" data-mp="2ie45ml0rln1s">
                            Deep insights & reporting
                          </div>
                        </div>
                      </Link>
                      <Link to="/voice-agents" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-626" data-mp="31gwjw2lcr68l">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-627" data-mp="28rz363wshhhy">
                          <Mic size={16} className="text-teal" data-id="element-628" data-mp="24rfabcj9101m" />
                        </div>
                        <div data-id="element-629" data-mp="2iqons4g2lg1w">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-630" data-mp="2irzqe0xs4hrf">
                            Voice Agents
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-631" data-mp="3u5bqq1ubyi8u">
                            AI that talks for you
                          </div>
                        </div>
                      </Link>
                      <Link to="/reputation-manager" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-632" data-mp="12bwwpmxc2pu">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-633" data-mp="a27cr7rfclw7">
                          <Star size={16} className="text-teal" data-id="element-634" data-mp="f08rjghthz1v" />
                        </div>
                        <div data-id="element-635" data-mp="3dkif9hsvsrye">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-636" data-mp="3dh4gejjff0vp">
                            Reputation Manager
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-637" data-mp="3ngc0rqokvvsb">
                            Protect your online image
                          </div>
                        </div>
                      </Link>
                      <Link to="/document-generator" className="flex items-start gap-3 p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-638" data-mp="2urwq1gchbzms">
                        <div className="w-8 h-8 rounded-lg bg-teal/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-639" data-mp="2s7rqmfyq22p4">
                          <FileText size={16} className="text-teal" data-id="element-640" data-mp="2n7cd9oefwv75" />
                        </div>
                        <div data-id="element-641" data-mp="2ibx06yo9b3bs">
                          <div className="text-sm font-semibold text-gray-800" data-id="element-642" data-mp="2dbisjhqkhvea">
                            Document Generator
                          </div>
                          <div className="text-xs text-gray-500" data-id="element-643" data-mp="29bifa0f7fq8t">
                            Auto-create branded docs
                          </div>
                        </div>
                      </Link>
                    </div>
                  </div>
                  {/* Column 4: Promo */}
                  <div className="bg-gradient-to-br from-purple to-[#852FF4] rounded-xl p-5 flex flex-col justify-between text-white" data-id="element-644" data-mp="1uievdme550ex">
                    <div data-id="element-645" data-mp="1ljbaccveyaxs">
                      <div className="text-lg font-poppins font-bold mb-2" data-id="element-646" data-mp="1lkw8ecgxsc0e">
                        Explore All Features
                      </div>
                      <p className="text-sm text-white/80 mb-4" data-id="element-647" data-mp="2actrhtf0ewjv">
                        See everything MR can do for your business — from AI
                        brains to full automation.
                      </p>
                    </div>
                    <Link to="/features" className="bg-white text-purple font-semibold text-sm px-4 py-2 rounded-lg text-center hover:bg-white/90 transition-colors" data-id="element-648" data-mp="25ipgmz2mi4di">
                      View All Features
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* ═══ SOLUTIONS MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-649" data-mp="1ml6gym221y3r">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-650" data-mp="3cx2ju1jopce1">
                Solutions <ChevronDown size={16} data-id="element-651" data-mp="3gy4ncukmwalt" />
              </span>
              <div className="absolute top-full left-0 w-[400px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-652" data-mp="15asuxzrciqn1">
                <div className="p-4 flex flex-col gap-1" data-id="element-653" data-mp="1f2oulf92yotd">
                  <Link to="/business-automation-systems" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-654" data-mp="1aaf86976c6vu">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-655" data-mp="1jzf7jtpl94ak">
                      <Zap size={18} className="text-teal" data-id="element-656" data-mp="1xyyg2nmbahne" />
                    </div>
                    <div data-id="element-657" data-mp="1t27yfvuuzdzv">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-658" data-mp="1t1y6w3u60ys2">
                        Business Automation
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-659" data-mp="3ut1j2xjpeleq">
                        End-to-end systems that work for you
                      </div>
                    </div>
                  </Link>
                  <Link to="/business-tasks-automated" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-660" data-mp="23nyaq2u0s4g6">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-661" data-mp="2cpo258nwj3dy">
                      <CheckSquare size={18} className="text-teal" data-id="element-662" data-mp="2hp0xyiwr3kso" />
                    </div>
                    <div data-id="element-663" data-mp="2mmkczl19w1lo">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-664" data-mp="2mm138rls0jiq">
                        Tasks Automated
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-665" data-mp="2wd5jrvr3ocfo">
                        Every repetitive task handled by AI
                      </div>
                    </div>
                  </Link>
                  <Link to="/industries" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-666" data-mp="35dtnnxms4weu">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-667" data-mp="to3y8of93q5v">
                      <Building2 size={18} className="text-teal" data-id="element-668" data-mp="kpsb4wdlfai6" />
                    </div>
                    <div data-id="element-669" data-mp="krmuw7d4owko">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-670" data-mp="fr8lolzsjgl2">
                        Industries
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-671" data-mp="1cggbw7bcudvb">
                        Solutions tailored to your industry
                      </div>
                    </div>
                  </Link>
                  <Link to="/enterprise" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-672" data-mp="13n3asi3505y5">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-673" data-mp="1w5qqfhzd6sru">
                      <Briefcase size={18} className="text-teal" data-id="element-674" data-mp="1rcnux4b11990" />
                    </div>
                    <div data-id="element-675" data-mp="zpvx870fpxoy">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-676" data-mp="zoktu8awiryd">
                        Enterprise
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-677" data-mp="pszvck51k9td">
                        Scale AI across your organization
                      </div>
                    </div>
                  </Link>
                  <Link to="/vs" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-678" data-mp="1igndztmr4qdd">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-679" data-mp="19gh4eiu6cajh">
                      <GitCompare size={18} className="text-teal" data-id="element-680" data-mp="1dhslu12w9pgl" />
                    </div>
                    <div data-id="element-681" data-mp="3u6pr1jqtd4ch">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-682" data-mp="3u6g5q9gprld4">
                        Compare Competitors
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-683" data-mp="20stx6kglcn3">
                        See how MR stacks up
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>

            {/* ═══ PRICING (simple link) ═══ */}
            <Link to="/pricing" className="text-sm font-medium text-gray-700 hover:text-teal transition-colors py-8" data-id="element-684" data-mp="4gsjkklodir9">
              Pricing
            </Link>

            {/* ═══ RESOURCES MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-685" data-mp="32zpp8n2mxw0l">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-686" data-mp="32xd11s6aapf3">
                Resources <ChevronDown size={16} data-id="element-687" data-mp="3cx3urrn0t0e4" />
              </span>
              <div className="absolute top-full left-0 w-[400px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-688" data-mp="3cviz1yoyzbeo">
                <div className="p-4 flex flex-col gap-1" data-id="element-689" data-mp="1jpfoz4qutdbn">
                  <Link to="/integrations" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-690" data-mp="1jr0ol8s0zmgd">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-691" data-mp="19xa2gajdfo3u">
                      <Puzzle size={18} className="text-purple" data-id="element-692" data-mp="22o1seq9ufgiq" />
                    </div>
                    <div data-id="element-693" data-mp="22lpeqpb4bsbh">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-694" data-mp="1xoffyj1ua4az">
                        Integrations
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-695" data-mp="1soavyj1q2rg0">
                        90+ tools MR connects to
                      </div>
                    </div>
                  </Link>
                  <Link to="/blog" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-696" data-mp="hbi8vljvmr6a">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-697" data-mp="2nzqzd4shel1b">
                      <BookOpen size={18} className="text-purple" data-id="element-698" data-mp="2sz3su8duyqcv" />
                    </div>
                    <div data-id="element-699" data-mp="2xw41mr23e77o">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-700" data-mp="2xvuav1983w0x">
                        Blog
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-701" data-mp="37mynvvfc96t4">
                        Tips, updates & AI insights
                      </div>
                    </div>
                  </Link>
                  <Link to="/case-studies" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-702" data-mp="3bqekwsvbl96c">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-703" data-mp="3lkn8d25hubxn">
                      <FileBarChart size={18} className="text-purple" data-id="element-704" data-mp="1r8p0p4mu1o3v" />
                    </div>
                    <div data-id="element-705" data-mp="1rajk2eigh85u">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-706" data-mp="1j7hdnflcjjr3">
                        Case Studies
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-707" data-mp="1f809cphnosni">
                        Real results from real businesses
                      </div>
                    </div>
                  </Link>
                  <a href="https://docs.mindstream.ing" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-708" data-mp="1o5ixi2qljn3m">
                    <div className="w-9 h-9 rounded-lg bg-purple/10 flex items-center justify-center shrink-0" data-id="element-709" data-mp="1y4rvd6ol1lv9">
                      <Code size={18} className="text-purple" data-id="element-710" data-mp="2bysn3gh4a8m4" />
                    </div>
                    <div data-id="element-711" data-mp="26ydbougebb6s">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-712" data-mp="2luvogk45a380">
                        Documentation
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-713" data-mp="2gwu4zy2t41w0">
                        Guides & technical reference
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            {/* ═══ COMPANY MEGA MENU ═══ */}
            <div className="relative group cursor-pointer py-8" data-id="element-714" data-mp="2qk6ljq9b5s53">
              <span className="flex items-center gap-1 text-sm font-medium text-gray-700 hover:text-teal transition-colors" data-id="element-715" data-mp="2vihqbmkqxcgg">
                Company <ChevronDown size={16} data-id="element-716" data-mp="2gsix7y81sr7u" />
              </span>
              <div className="absolute top-full right-0 w-[400px] bg-white border border-gray-100 rounded-xl shadow-2xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all translate-y-2 group-hover:translate-y-0" data-id="element-717" data-mp="2lkacvdpo1cj7">
                <div className="p-4 flex flex-col gap-1" data-id="element-718" data-mp="2ct1omvxbrdyg">
                  <Link to="/about" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-719" data-mp="1xupscqdv677t">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-720" data-mp="22vx4t2qybukt">
                      <Info size={18} className="text-teal" data-id="element-721" data-mp="315n5yw75gl6q" />
                    </div>
                    <div data-id="element-722" data-mp="317q3006pzeky">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-723" data-mp="2wenalvdoib6c">
                        About
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-724" data-mp="2rf0w7im46ovy">
                        Our story and mission
                      </div>
                    </div>
                  </Link>
                  <Link to="/partners" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-725" data-mp="2ievy5z2t92ug">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-726" data-mp="28hhk264d0q5b">
                      <Handshake size={18} className="text-teal" data-id="element-727" data-mp="boxy3p0g71gt" />
                    </div>
                    <div data-id="element-728" data-mp="6p32571tflow">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-729" data-mp="6qwd2yjgos2p">
                        Partners
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-730" data-mp="e79nr18apy29">
                        White-label & reseller program
                      </div>
                    </div>
                  </Link>
                  <Link to="/community" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-731" data-mp="o107xtxe3mc5">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-732" data-mp="3rhgsmyivggeh">
                      <Users size={18} className="text-teal" data-id="element-733" data-mp="bfh6ouzvksb" />
                    </div>
                    <div data-id="element-734" data-mp="574hiueu95po">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-735" data-mp="a7isak7tqtre">
                        Community
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-736" data-mp="1gmjehy71rxks">
                        Join the MR community
                      </div>
                    </div>
                  </Link>
                  <Link to="/contact" className="flex items-start gap-3 p-3 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-737" data-mp="3hp11cmz3gt90">
                    <div className="w-9 h-9 rounded-lg bg-teal/10 flex items-center justify-center shrink-0" data-id="element-738" data-mp="3qq8lm14rztk3">
                      <Mail size={18} className="text-teal" data-id="element-739" data-mp="3modprc5m68dp" />
                    </div>
                    <div data-id="element-740" data-mp="2yz2ta6var05d">
                      <div className="text-sm font-semibold text-gray-800" data-id="element-741" data-mp="2z0dy8a0hady2">
                        Contact
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-742" data-mp="2ty51d2khirqo">
                        Get in touch with our team
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Right Actions */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-743" data-mp="2f9ipxbxzak4q">
            <Link to="/contact" className="btn-primary py-2.5 px-6 text-sm" data-id="element-744" data-mp="2b8ozobx2ct8o">
              Talk to MR
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button className="lg:hidden text-navy-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-745" data-mp="25w9syvlggmqo">
            {isMobileMenuOpen ? <X size={24} data-id="element-746" data-mp="1r9gkoaacsh7z" /> : <Menu size={24} data-id="element-747" data-mp="1r5sthhsds6wf" />}
          </button>
        </div>
      </div>

      {/* Layer 3: Bottom Category Bar */}
      <div className="bg-[#0785B7] text-white h-[32px] shadow-[inset_0_1px_0_rgba(255,255,255,0.15),inset_0_-1px_0_rgba(0,0,0,0.15),0_2px_6px_rgba(0,0,0,0.1)] overflow-hidden" data-id="element-748" data-mp="2jwkmk6e5gffj">
        {/* Desktop: static centered */}
        <div className="hidden md:flex max-w-7xl mx-auto px-6 h-full items-center justify-center gap-8 text-sm font-semibold tracking-wide whitespace-nowrap" data-id="element-749" data-mp="29ywnx5dfans3">
          <Link to="/self-building-website" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-750" data-mp="2ez19vax3oapp">
            🌐 Self-Building Websites
          </Link>
          <span className="text-white/30" data-id="element-751" data-mp="kr8r15wu5l8r">|</span>
          <Link to="/self-managing-crm" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-752" data-mp="kt3dwpro3nfh">
            🤖 Self-Running CRM
          </Link>
          <span className="text-white/30" data-id="element-753" data-mp="atujjvsw46sl">|</span>
          <Link to="/project-manager" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-754" data-mp="6s0r2asum93i">
            📋 Self-Managing Projects
          </Link>
          <span className="text-white/30" data-id="element-755" data-mp="yiezvsm08v8b">|</span>
          <Link to="/self-running-marketing" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-756" data-mp="yl01qhmazb62">
            📣 Self-Running Marketing
          </Link>
          <span className="text-white/30" data-id="element-757" data-mp="posdgt3ot4bs">|</span>
          <Link to="/team-of-20" className="hover:underline underline-offset-4 transition-all whitespace-nowrap" data-id="element-758" data-mp="1m9j6woa237tx">
            👥 Meet Your Team of 20
          </Link>
        </div>
        {/* Mobile: auto-scrolling marquee */}
        <div className="md:hidden h-full flex items-center" data-id="element-759" data-mp="353cd1w54qtk5">
          <div className="animate-marquee-teal flex items-center gap-6 text-sm font-semibold tracking-wide whitespace-nowrap" data-id="element-760" data-mp="353vu7amyhdx4">
            <Link to="/self-building-website" className="whitespace-nowrap" data-id="element-761" data-mp="3e4ahugne753s">
              🌐 Self-Building Websites
            </Link>
            <span className="text-white/30" data-id="element-762" data-mp="3j2c1b2oqd6fs">|</span>
            <Link to="/self-managing-crm" className="whitespace-nowrap" data-id="element-763" data-mp="3j1kfukoukp38">
              🤖 Self-Running CRM
            </Link>
            <span className="text-white/30" data-id="element-764" data-mp="3ssoj4n55uli8">|</span>
            <Link to="/project-manager" className="whitespace-nowrap" data-id="element-765" data-mp="3stzxti059do4">
              📋 Self-Managing Projects
            </Link>
            <span className="text-white/30" data-id="element-766" data-mp="5oihk6da5blg">|</span>
            <Link to="/self-running-marketing" className="whitespace-nowrap" data-id="element-767" data-mp="5ptgnsvs5v68">
              📣 Self-Running Marketing
            </Link>
            <span className="text-white/30" data-id="element-768" data-mp="al8tqilyrn1l">|</span>
            <Link to="/team-of-20" className="whitespace-nowrap" data-id="element-769" data-mp="1e6q3mv5nrwsw">
              👥 Meet Your Team of 20
            </Link>
            <span className="text-white/30 mx-4" data-id="element-770" data-mp="1j503hj2bvlku">|</span>
            <Link to="/self-building-website" className="whitespace-nowrap" data-id="element-771" data-mp="1nxb28ilc11bt">
              🌐 Self-Building Websites
            </Link>
            <span className="text-white/30" data-id="element-772" data-mp="1sw4j8kztvagq">|</span>
            <Link to="/self-managing-crm" className="whitespace-nowrap" data-id="element-773" data-mp="v9f89ln5dniq">
              🤖 Self-Running CRM
            </Link>
            <span className="text-white/30" data-id="element-774" data-mp="1091kbrr8oxpy">|</span>
            <Link to="/project-manager" className="whitespace-nowrap" data-id="element-775" data-mp="15733sdskuz1y">
              📋 Self-Managing Projects
            </Link>
            <span className="text-white/30" data-id="element-776" data-mp="198x2igj7pszh">|</span>
            <Link to="/self-running-marketing" className="whitespace-nowrap" data-id="element-777" data-mp="196kbzeze2aat">
              📣 Self-Running Marketing
            </Link>
            <span className="text-white/30" data-id="element-778" data-mp="2knalb6z3zi8n">|</span>
            <Link to="/team-of-20" className="whitespace-nowrap" data-id="element-779" data-mp="2km0m2egis40f">
              👥 Meet Your Team of 20
            </Link>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white border-b-2 border-teal shadow-2xl overflow-y-auto max-h-[calc(100vh-80px)]" data-id="element-780" data-mp="5195rruzd2d1">
          <div className="p-6 flex flex-col gap-6" data-id="element-781" data-mp="3rdofh4e8fei6">
            <div className="flex flex-col gap-4" data-id="element-782" data-mp="3mfd76y3l5c22">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-783" data-mp="3mg63t68tyl6h">
                How It Works
              </div>
              <Link to="/how-it-works/meet-mr" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-784" data-mp="3himrwczlukhp">
                1. Meet MR
              </Link>
              <Link to="/how-it-works/business-deep-dive" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-785" data-mp="1bm0kheis3w20">
                2. Business Deep Dive
              </Link>
              <Link to="/how-it-works/intake-upload" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-786" data-mp="1uju09tsqpf1e">
                3. Intake/Upload All Data
              </Link>
              <Link to="/how-it-works/brand-persona" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-787" data-mp="29gur7v33x5yt">
                4. Create Brand Persona
              </Link>
              <Link to="/how-it-works/create-agents" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-788" data-mp="1zkrg3zqa1wzq">
                5. Create & Implement Agents
              </Link>
              <Link to="/how-it-works/review-process" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-789" data-mp="t45x0ph9oy5b">
                6. Review The Process
              </Link>
              <Link to="/how-it-works/revamp-repeat" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-790" data-mp="uip8efx94zb1">
                7. Revamp & Repeat
              </Link>
              <Link to="/how-it-works" className="text-sm font-semibold text-teal hover:text-navy-dark mt-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-791" data-mp="3tz5d3vfzla47">
                View Full Process →
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-792" data-mp="3f9zcc31i3bu7">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-793" data-mp="3f8ekil6km701">
                Features
              </div>
              <Link to="/think-tank" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-794" data-mp="3a91yg2nix3yi">
                ThinkTank
              </Link>
              <Link to="/live-mind-maps" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-795" data-mp="1q5820fchbhp">
                Live Mind Maps
              </Link>
              <Link to="/persona-builder" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-796" data-mp="al2zf32ugg6x">
                Persona Builder
              </Link>
              <Link to="/dedicated-line" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-797" data-mp="peoe09ax9c6m">
                Dedicated Line
              </Link>
              <Link to="/project-manager" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-798" data-mp="18c84l37nws1d">
                Project Manager
              </Link>
              <Link to="/self-building-website" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-799" data-mp="zkfsyp6wjcv7">
                Self-Building Website
              </Link>
              <Link to="/self-running-marketing" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-800" data-mp="1n98vx5lxykzb">
                Self-Running Marketing
              </Link>
              <Link to="/onboarding-agents" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-801" data-mp="6v8utrbd0pah">
                Onboarding Agents
              </Link>
              <Link to="/self-managing-crm" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-802" data-mp="3e4fgxx7rp8l">
                Self-Managing CRM
              </Link>
              <Link to="/advanced-analytics" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-803" data-mp="3vgce53jcuyzu">
                Advanced Analytics
              </Link>
              <Link to="/voice-agents" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-804" data-mp="3lkslqr402ifu">
                Voice Agents
              </Link>
              <Link to="/reputation-manager" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-805" data-mp="2xuerqv1uu9im">
                Reputation Manager
              </Link>
              <Link to="/document-generator" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-806" data-mp="2e7tlim7itqsz">
                Document Generator
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-807" data-mp="2o83zi91dr297">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-808" data-mp="324h8suvrfxcl">
                Solutions
              </div>
              <Link to="/business-automation-systems" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-809" data-mp="2x65zqmdahqvf">
                Business Automation Systems
              </Link>
              <Link to="/business-tasks-automated" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-810" data-mp="3kwjrebrypnph">
                Business Tasks Automated
              </Link>
              <Link to="/industries" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-811" data-mp="w2a9vkasa8ry">
                Industries
              </Link>
              <Link to="/enterprise" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-812" data-mp="151nkigan93e9">
                Enterprise
              </Link>
              <Link to="/vs" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-813" data-mp="hdxb6fkbabtr">
                Compare Competitors
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-814" data-mp="3lqkm7ozcu05e">
              <Link to="/pricing" className="text-sm font-bold text-cyan-400 uppercase tracking-wider hover:text-cyan-300" onClick={() => setIsMobileMenuOpen(false)} data-id="element-815" data-mp="3pso3iu8pfyyl">
                Pricing
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-816" data-mp="398qfq56w7xw4">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-817" data-mp="39bme1umnkol3">
                Resources
              </div>
              <Link to="/integrations" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-818" data-mp="2zc5594c3tukw">
                Integrations
              </Link>
              <Link to="/blog" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-819" data-mp="2pjpqefw3tm48">
                Blog
              </Link>
              <Link to="/case-studies" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-820" data-mp="2bmaz15maj49m">
                Case Studies
              </Link>
              <a href="https://docs.mindstream.ing" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-821" data-mp="1gi3df7kq54vx">
                Documentation
              </a>
            </div>

            <div className="flex flex-col gap-4" data-id="element-822" data-mp="1phhytsm1ap9k">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-823" data-mp="11urzx04zfat6">
                Company
              </div>
              <Link to="/about" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-824" data-mp="wwgq2peot0ay">
                About
              </Link>
              <Link to="/partners" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-825" data-mp="j2z6j4m03nkx">
                Partners
              </Link>
              <Link to="/community" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-826" data-mp="2pqprt1pytsvw">
                Community
              </Link>
              <Link to="/contact" className="text-sm text-gray-600 hover:text-navy-dark" onClick={() => setIsMobileMenuOpen(false)} data-id="element-827" data-mp="2ksegemk0vabk">
                Contact
              </Link>
            </div>

            <div className="flex flex-col gap-4" data-id="element-828" data-mp="3dgk1xbiwh3cg">
              <div className="text-xs font-bold text-teal uppercase tracking-wider" data-id="element-829" data-mp="2zhkoz14r2cw4">
                Login
              </div>
              <a href="https://app.1dash.pro" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-830" data-mp="34fcghu1hfwzs">
                1Dash
              </a>
              <a href="https://app.dartai.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-831" data-mp="3uqei3fh8hcvi">
                Dart AI
              </a>
              <a href="https://thinktank.mindstream.ing" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-832" data-mp="3kys112i7sjku">
                ThinkTank
              </a>
              <a href="https://members.mindstream.ing" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-600 hover:text-navy-dark" data-id="element-833" data-mp="37022rjjnsduw">
                Community
              </a>
            </div>

            <Link to="/contact" className="btn-primary w-full mt-4 text-center" onClick={() => setIsMobileMenuOpen(false)} data-id="element-834" data-mp="109cewktxxj1j">
              Talk to MR
            </Link>
          </div>
        </div>}
    </nav>;
}